import html2canvas from 'html2canvas';
import { previewCatalogTemplateHtml } from '../../../app/api';

const PREVIEW_CAPTURE_WIDTH = 1280;
const LOAD_TIMEOUT_MS = 12000;
const SETTLE_MS = 1200;

const waitForIframeReady = (iframe) =>
  new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('Preview capture timeout')), LOAD_TIMEOUT_MS);
    iframe.addEventListener(
      'load',
      () => {
        clearTimeout(timer);
        setTimeout(resolve, SETTLE_MS);
      },
      { once: true },
    );
  });

export const captureCatalogTemplateDesktopPreview = async ({
  catalogId,
  templateJson,
  instanceJson,
}) => {
  if (!catalogId) {
    throw new Error('catalog_id is required for preview capture');
  }
  const html = await previewCatalogTemplateHtml({
    catalog_id: catalogId,
    template_json: templateJson,
    instance_json: instanceJson,
    preview_mode: 'desktop',
    allow_synthetic: true,
  });

  const iframe = document.createElement('iframe');
  iframe.setAttribute('title', 'catalog-template-preview-capture');
  iframe.setAttribute('sandbox', 'allow-same-origin allow-scripts');
  iframe.style.position = 'fixed';
  iframe.style.left = '-20000px';
  iframe.style.top = '0';
  iframe.style.width = `${PREVIEW_CAPTURE_WIDTH}px`;
  iframe.style.height = '900px';
  iframe.style.border = '0';
  iframe.srcdoc = html;
  document.body.appendChild(iframe);

  try {
    await waitForIframeReady(iframe);
    const doc = iframe.contentDocument;
    const target = doc?.body;
    if (!target) {
      throw new Error('Preview iframe body not available');
    }
    const canvas = await html2canvas(target, {
      width: PREVIEW_CAPTURE_WIDTH,
      height: Math.min(target.scrollHeight || 900, 2400),
      scale: 1,
      useCORS: true,
      allowTaint: true,
      logging: false,
      backgroundColor: '#ffffff',
    });
    const blob = await new Promise((resolve, reject) => {
      canvas.toBlob((result) => {
        if (result) resolve(result);
        else reject(new Error('Failed to encode preview image'));
      }, 'image/png', 0.92);
    });
    return blob;
  } finally {
    iframe.remove();
  }
};
